<ng-container formContent>
  <span class="text-secondary fs-14">Un contrat à votre image.</span>

  <form [formGroup]="criteriaForm">
    <pr-input-abstract
      label="Type de support"
      class="mvl"
      style="display: block"
      [disabled]="avDistribution === 'PILOTED'"
    >
      <mat-select formControlName="supportTypes" placeholder="Tous">
        <mat-option [value]="undefined">Tous</mat-option>
        @for (type of supportTypes | async; track type) {
          <mat-option [value]="type.id">
            {{ type.value }}
          </mat-option>
        }
      </mat-select>
    </pr-input-abstract>
    @if (avDistribution !== 'PILOTED') {
      <pr-input-radio
        formControlName="enableViewAll"
        columns="3"
        [toggle]="true"
        [isDefault]="true"
        label="Voir les produits structurés expirés"
      >
      </pr-input-radio>
    }

    <pr-search-input
      formControlName="autocomplete"
      placeholder="Rechercher un support"
      class="mbm"
    >
    </pr-search-input>
  </form>
  <pr-form-select-list #formSelectList>
    @for (support of supports; track support) {
      <pr-form-select-list-option
        [label]="support.name"
        [labelIcon]="support.favorite ? 'sp-cup' : undefined"
        [subLabel]="support.isin"
        [criteriasLoading]="criteriasLoading"
        [selected]="
          _.map(form.get('supportRepartition').value, 'isin').includes(
            support.isin
          )
        "
        [criterias]="[
          {
            label: 'Performance sur 1 an',
            value: getPerf(support),
            options: { color: getPerfColor(support) },
          },
          {
            label: 'Niveau de risque',
            value: getRisk(support),
            options: { color: getRiskColor(support) },
          },
        ]"
        (onSelect)="onSupportSelect(support)"
        (onDeselect)="onSupportDeselect(support)"
        [withMoreInfoAnchor]="support.id"
        (onMoreInfoClick)="onMoreInfoClick(support)"
      >
      </pr-form-select-list-option>
    }
  </pr-form-select-list>
  <mat-paginator
    [length]="supportsLength"
    [pageSize]="supportsPageSize"
    (page)="changeSupportsPage($event)"
  >
  </mat-paginator>
</ng-container>
